import { useState } from "react";

import { useToast } from "@/ds";
import {
  FICHAS_DIALOG_TITLE,
  FICHA_VIEWER_TITLE,
  PREVIA_BLOQUEADA_LIFE,
} from "./financeiro-fichas-dialog.constants";
import type { FinanceiroFichasDialogProps } from "./types-financeiro-fichas-dialog";

/**
 * Modal das fichas financeiras da obra (HU 2679): moldura e navegação entre a listagem
 * (`FichasTabela`, dona da consulta e dos estados) e a consulta somente leitura de uma ficha.
 * "Gerar ficha" (HU 2684) abre a prévia no lugar da listagem. Não há seta de voltar: o X fecha só a tela atual
 * (ficha ou prévia voltam à listagem; na listagem, volta ao detalhamento).
 */
export function useFinanceiroFichasDialog({ obraId, onClose }: FinanceiroFichasDialogProps) {
  const [fichaId, setFichaId] = useState<string | null>(null);
  const [gerando, setGerando] = useState(false);
  const [geracaoSalva, setGeracaoSalva] = useState(false);
  const [recarregarEm, setRecarregarEm] = useState(0);
  const toast = useToast();

  function voltarParaListagem() {
    setFichaId(null);
    setGerando(false);
    setGeracaoSalva(false);
  }

  const emPrevia = gerando && !geracaoSalva;

  return {
    obraId,
    fichaId,
    emFicha: fichaId !== null,
    gerando,
    naListagem: fichaId === null && !gerando,
    emPrevia,
    dialogClassName: fichaId === null && !gerando ? "p-dialog-ficha-lista" : "p-dialog-ficha",
    titulo: fichaId === null && (!gerando || emPrevia) ? FICHAS_DIALOG_TITLE : FICHA_VIEWER_TITLE,
    recarregarEm,
    abrirFicha: (id: string) => setFichaId(id),
    fechar: fichaId !== null || gerando ? voltarParaListagem : onClose,
    gerarFicha: () => {
      setGeracaoSalva(false);
      setGerando(true);
    },
    encerrarGeracao: voltarParaListagem,
    // O core recusou a prévia (422, MS006): aviso por cima da listagem, que volta sem abrir a prévia.
    previaBloqueada: (mensagem: string) => {
      voltarParaListagem();
      toast.show({ severity: "warn", summary: mensagem, life: PREVIA_BLOQUEADA_LIFE });
    },
    fichaSalva: () => {
      setGeracaoSalva(true);
      setRecarregarEm((atual) => atual + 1);
    },
  };
}
